import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { KYMW1002Component } from './kymw/kymw10/kymw1002/kymw1002.component';
import { KYMWComponent } from './kymw/kymw.component';
import { KYMW1200Component } from './kymw/kymw12/kymw1200/kymw1200.component';
import { KYMW1300Component } from './kymw/kymw13/kymw1300/kymw1300.component';
import { KYMW1201Component } from './kymw/kymw12/kymw1201/kymw1201.component';
import { KYMW2400Component } from './kymw/kymw24/kymw2400/kymw2400.component';
import { KYMW0A00Component } from './commons/kymw0a/kymw0a00/kymw0a00.component';
import { TestComponent } from './kymw/test/test.component';
import { KYMW1000Component } from './kymw/kymw10/kymw1000/kymw1000.component';
import { authGuard } from './auth.guard';
import { leaveConfirmGuard } from './shared/utils/leave-confirm.guard';
import { KYMW2100Component } from './kymw/kymw21/kymw2100/kymw2100.component';
import { KYMW2300Component } from './kymw/kymw23/kymw2300/kymw2300.component';
import { KYMW2500Component } from './kymw/kymw25/kymw2500/kymw2500.component';
import { KYMW1700Component } from './kymw/kymw17/kymw1700/kymw1700.component';
import { KYMW1800Component } from './kymw/kymw18/kymw1800/kymw1800.component';
import { KYMW1100Component } from './kymw/kymw11/kymw1100/kymw1100.component';
import { KYMW2800Component } from './kymw/kymw28/kymw2800/kymw2800.component';
import { KYMW4200Component } from './kymw/kymw42/kymw4200/kymw4200.component';
import { KYMW1400Component } from './kymw/kymw14/kymw1400/kymw1400.component';
import { KYMW4400Component } from './kymw/kymw44/kymw4400/kymw4400.component';
import { KYMW4500Component } from './kymw/kymw45/kymw4500/kymw4500.component';
import { KYMW2600Component } from './kymw/kymw26/kymw2600/kymw2600.component';
import { KYMW2700Component } from './kymw/kymw27/kymw2700/kymw2700.component';
import { KYMW2900Component } from './kymw/kymw29/kymw2900/kymw2900.component';
import { KYMW2200Component } from './kymw/kymw22/kymw2200/kymw2200.component';
import { KYMW1500Component } from './kymw/kymw15/kymw1500/kymw1500.component';
import { KYMW4100Component } from './kymw/kymw41/kymw4100/kymw4100.component';
import { KYMW5300Component } from './kymw/kymw53/kymw5300/kymw5300.component';
import { KYMW5400Component } from './kymw/kymw54/kymw5400/kymw5400.component';
import { KYMW5500Component } from './kymw/kymw55/kymw5500/kymw5500.component';
import { KYMW5900Component } from './kymw/kymw59/kymw5900/kymw5900.component';
import { KYMW6000Component } from './kymw/kymw60/kymw6000/kymw6000.component';
import { KYMW6100Component } from './kymw/kymw61/kymw6100/kymw6100.component';
import { KYMW6500Component } from './kymw/kymw65/kymw6500/kymw6500.component';
import { KYMW6600Component } from './kymw/kymw66/kymw6600/kymw6600.component';
import { KYMW6700Component } from './kymw/kymw67/kymw6700/kymw6700.component';
import { KYMW6800Component } from './kymw/kymw68/kymw6800/kymw6800.component';

import { KYMW1600Component } from './kymw/kymw16/kymw1600/kymw1600.component';
import { KYMW4000Component } from './kymw/kymw40/kymw4000/kymw4000.component';
import { KYMW4300Component } from './kymw/kymw43/kymw4300/kymw4300.component';
import { KYMW4600Component } from './kymw/kymw46/kymw4600/kymw4600.component';
import { KYMW4700Component } from './kymw/kymw47/kymw4700/kymw4700.component';
import { KYMW4800Component } from './kymw/kymw48/kymw4800/kymw4800.component';
import { KYMW4801Component } from './kymw/kymw48/kymw4801/kymw4801.component';
import { KYMW7300Component } from './kymw/kymw73/kymw7300/kymw7300.component';
import { KYMW7400Component } from './kymw/kymw74/kymw7400/kymw7400.component';
import { KYMW7402Component } from './kymw/kymw74/kymw7402/kymw7402.component';
import { KYMW9000Component } from './kymw/kymw90/kymw9000/kymw9000.component';
import { KYMW9003Component } from './kymw/kymw90/kymw9003/kymw9003.component';
import { KYMW9006Component } from './kymw/kymw90/kymw9006/kymw9006.component';
import { KYMW9009Component } from './kymw/kymw90/kymw9009/kymw9009.component';
import { KYMW9100Component } from './kymw/kymw91/kymw9100/kymw9100.component';
import { KYMW9200Component } from './kymw/kymw92/kymw9200/kymw9200.component';
import { KYMW9400Component } from './kymw/kymw94/kymw9400/kymw9400.component';
import { KYMW9300Component } from './kymw/kymw93/kymw9300/kymw9300.component';
import { KYMW7000Component } from './kymw/kymw70/kymw7000/kymw7000.component';
import { KYMW7001Component } from './kymw/kymw70/kymw7001/kymw7001.component';
import { KYMW7002Component } from './kymw/kymw70/kymw7002/kymw7002.component';
import { KYMW7003Component } from './kymw/kymw70/kymw7003/kymw7003.component';
import { KYMW7004Component } from './kymw/kymw70/kymw7004/kymw7004.component';
import { KYMW7005Component } from './kymw/kymw70/kymw7005/kymw7005.component';
import { KYMW7006Component } from './kymw/kymw70/kymw7006/kymw7006.component';
import { KYMW7007Component } from './kymw/kymw70/kymw7007/kymw7007.component';
import { KYMW7200Component } from './kymw/kymw72/kymw7200/kymw7200.component';
import { KYMW7201Component } from './kymw/kymw72/kymw7201/kymw7201.component';
import { KYMW7100Component } from './kymw/kymw71/kwmy7100/kymw7100.component';
import { KYMW6001Component } from './kymw/kymw60/kymw6001/kymw6001.component';
import { KYMW6900Component } from './kymw/kymw69/kymw6900/kymw6900.component';
import { KYMW6901Component } from './kymw/kymw69/kymw6901/kymw6901.component';
import { KYMW9008Component } from './kymw/kymw90/kymw9008/kymw9008.component';
import { KYMW9007Component } from './kymw/kymw90/kymw9007/kymw9007.component';
import { KYMW7500Component } from './kymw/kymw75/kymw7500/kymw7500.component';
import { KYMW0C00Component } from './commons/kymw0c/kymw0c00/kymw0c00.component';
import { KYMW1003Component } from './kymw/kymw10/kymw1003/kymw1003.component';
import { AuthComponent } from './kymw/kymw10/auth/auth.component';
import { EmployeeComponent } from './kymw/kymw10/employee/employee.component';
import { PartnerComponent } from './kymw/kymw10/partner/partner.component';
import { KYMW9011Component } from './kymw/kymw90/kymw9011/kymw9011.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [],
    children: [
      { path: 'login', component: KYMW1000Component },
      { path: 'auth', component: AuthComponent },
      { path: 'employee', component: EmployeeComponent },
      { path: 'partner', component: PartnerComponent },
      { path: 'kymw/1003', component: KYMW1003Component },
      { path: 'kymw/9007', component: KYMW9007Component },
      { path: 'kymw/9008', component: KYMW9008Component, canActivate: [authGuard] },
      { path: 'kymw/9011', component: KYMW9011Component },
      {
        path: 'subwindow',
        canActivate: [authGuard],
        children: [
          { path: 'kymw/1200', component: KYMW1200Component },
        ],
      },
      {
        path: 'kymw',
        component: KYMWComponent,
        canActivate: [authGuard],
        children: [
          { path: '1002', component: KYMW1002Component, data: { title: 'ダッシュボード' } },
          // バイヤー
          { path: '1100', component: KYMW1100Component, data: { title: '商品マスタ' }, canDeactivate: [leaveConfirmGuard] },
          { path: '1200', component: KYMW1200Component, data: { title: 'サイクル設定' }, canDeactivate: [leaveConfirmGuard] },
          { path: '1300', component: KYMW1300Component, data: { title: '商品企画マスタ' }, canDeactivate: [leaveConfirmGuard] }, // 選定候補一覧/選定済一覧なのかな?
          { path: '2800', component: KYMW2800Component, data: { title: '週別部門別供給高ＧＰ予算進捗' } },
          { path: '4200', component: KYMW4200Component, data: { title: '商品マスタプルーフ' } },
          { path: '6900', component: KYMW6900Component, data: { title: '商品提案検索' } },
          { path: '6901', component: KYMW6901Component, data: { title: '新規商品提案' } },
          { path: '7000', component: KYMW7000Component, data: { title: '表紙・特集掲載商品選定' } },
          { path: '7001', component: KYMW7001Component, data: { title: '表紙・特集掲載商品選定' } },
          { path: '7500', component: KYMW7500Component, data: { title: '計画数確認' } },
          // 編集
          { path: '1400', component: KYMW1400Component, data: { title: 'コマ割' }, canDeactivate: [leaveConfirmGuard] },
          { path: '4400', component: KYMW4400Component, data: { title: 'ページ・台割編集' } },
          { path: '2600', component: KYMW2600Component, data: { title: 'Ｗ掲載リスト出力' } },
          { path: '2700', component: KYMW2700Component, data: { title: '基版コピー・フェーズ管理' }, canDeactivate: [leaveConfirmGuard] },
          { path: '2100', component: KYMW2100Component, data: { title: '注文コード設定' }, canDeactivate: [leaveConfirmGuard] },
          { path: '2900', component: KYMW2900Component, data: { title: '農産フロントシステム連携' } },
          { path: '2300', component: KYMW2300Component, data: { title: '印刷会社用データ出力' }, canDeactivate: [leaveConfirmGuard] },
          { path: '2200', component: KYMW2200Component, data: { title: 'ＯＣＲデータメール送信' } },
          { path: '2400', component: KYMW2400Component, data: { title: 'ページパターン設定' } }, // ページテンプレートなのかな?
          { path: '2500', component: KYMW2500Component, data: { title: 'ページネーション設定' } },
          { path: '0A00', component: KYMW0A00Component, data: { title: '組合員の声管理' } },
          { path: '1500', component: KYMW1500Component, data: { title: 'マーク・アイコンマスタ' }, canDeactivate: [leaveConfirmGuard] },
          { path: '4100', component: KYMW4100Component, data: { title: '統一企画点検リスト' } },
          { path: '4500', component: KYMW4500Component, data: { title: '特集マスタ' } },
          // EC
          { path: '5300', component: KYMW5300Component, data: { title: 'ECカテゴリマスタ' }, canDeactivate: [leaveConfirmGuard] },
          { path: '5400', component: KYMW5400Component, data: { title: 'ECカテゴリ関連マスタ' }, canDeactivate: [leaveConfirmGuard] },
          { path: '5500', component: KYMW5500Component, data: { title: 'EC画像メンテ' } },
          { path: '5900', component: KYMW5900Component, data: { title: 'EC企画商品一覧表' } },
          { path: '6000', component: KYMW6000Component, data: { title: 'EC使用画像一覧' } },
          { path: '6001', component: KYMW6001Component, data: { title: '商品画像情報' } },
          { path: '6100', component: KYMW6100Component, data: { title: 'EC画像指示一覧表' } },
          { path: '6500', component: KYMW6500Component, data: { title: 'ECタイムセールマスタ一覧' } },
          { path: '6600', component: KYMW6600Component, data: { title: '特別指示書' } },
          { path: '6700', component: KYMW6700Component, data: { title: '校正紙' } },
          { path: '6800', component: KYMW6800Component, data: { title: 'ECカテゴリ変換マスタ一覧' } },
          // いつでも注文: 全て対象外(3000,3100,3200,3300,3400,3500)
          // その他
          { path: '1600', component: KYMW1600Component, data: { title: '画像確認' }, canDeactivate: [leaveConfirmGuard] },
          { path: '1800', component: KYMW1800Component, data: { title: '画像チェックリスト出力' } },
          { path: '1700', component: KYMW1700Component, data: { title: '画像作成管理' } },
          { path: '0c00', component: KYMW0C00Component, data: { title: '画像作成指示' }, canDeactivate: [leaveConfirmGuard] },
          { path: '4000', component: KYMW4000Component, data: { title: '週次プロモーション商品計画表' } },
          { path: '4300', component: KYMW4300Component, data: { title: '商品ＤＮＡ情報一覧' } },
          { path: '1201', component: KYMW1201Component, data: { title: '企画回別商品一覧' }, canDeactivate: [leaveConfirmGuard] },
          { path: '4600', component: KYMW4600Component, data: { title: 'タグ管理' } },
          { path: '7001', component: KYMW7001Component, data: { title: '表紙特集掲載商品選定' } },
          { path: '7002', component: KYMW7002Component, data: { title: '特集商品提案' } },
          { path: '7003', component: KYMW7003Component, data: { title: '特集商品提案状況確認' } },
          { path: '7004', component: KYMW7004Component, data: { title: '特集商品提案状況確認' } },
          { path: '7005', component: KYMW7005Component, data: { title: '特集商品付替' } },
          { path: '7006', component: KYMW7006Component, data: { title: '表紙・特集商品選定依頼確認' } },
          { path: '7007', component: KYMW7007Component, data: { title: '表紙・特集商品選定依頼確認' } },
          { path: '7200', component: KYMW7200Component, data: { title: '運営商品一覧' } },
          { path: '7201', component: KYMW7201Component, data: { title: '運営商品登録' } },
          { path: '7300', component: KYMW7300Component, data: { title: '注文単位値引クーポン一覧' } },
          { path: '7400', component: KYMW7400Component, data: { title: '忘れず注文商品一覧' } },
          { path: '7402', component: KYMW7402Component, data: { title: '忘れず注文商品登録' } },
          // システム管理
          { path: '7100', component: KYMW7100Component, data: { title: '束ね企画回設定' } },
          { path: '9000', component: KYMW9000Component, data: { title: 'ユーザ一覧' } },
          { path: '9003', component: KYMW9003Component, data: { title: '権限一覧' } },
          { path: '9006', component: KYMW9006Component, data: { title: 'パスワード変更' } },
          { path: '9009', component: KYMW9009Component, data: { title: 'ユーザ階層管理' }, canDeactivate: [leaveConfirmGuard] },
          { path: '9100', component: KYMW9100Component, data: { title: 'ログ検索' } },
          { path: '9200', component: KYMW9200Component, data: { title: '企画回管理' } },
          { path: '9300', component: KYMW9300Component, data: { title: 'お知らせ編集' } },
          { path: '9400', component: KYMW9400Component, data: { title: '外部システム連携' } },
          { path: 'test', component: TestComponent, data: { title: 'テスト' } },
          // マスタ管理
          { path: '4700', component: KYMW4700Component, data: { title: 'マルチコード一覧' } },
          { path: '4800', component: KYMW4800Component, data: { title: 'クロス商品設定マスタ管理' } },
          { path: '4801', component: KYMW4801Component, data: { title: 'クロス設定登録' } },
        ]
      },
      {
        path: 'kymw',
        canActivate: [],
        children: [
          // その他
          { path: '**', component: AuthComponent },
        ],
      },
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {}),
  ],
  exports: [
    RouterModule,
  ],
})

export class AppRoutingModule { }
